import React, {useMemo} from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import {makeTableData} from './utils';
import DateIntervalPicker from '../Forms/DateIntervalPicker';
import SimpleTable from './SimpleTable';
import useSearch from '../../hooks/useSearch';
import Search from '../Inputs/Search';
import useStyles from './styles';

const View = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onRowClick,
  data,
  isBusy,
}) => {
  return <>
    <Header
      {...{startDate, setStartDate, endDate, setEndDate}}
    />
    <Table {...{isBusy, onRowClick, data}} />
  </>;
};

export const Header = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {

  const classes = useStyles();

  return <Grid
    container
    justify="center"
    alignItems="center"
    className={classes.header}
  >
    <Grid item xs={12}>
      <DateIntervalPicker
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
  </Grid>;
};

const Table = ({
  data,
  onRowClick,
  isBusy
}) => {

  const classes = useStyles();

  const listData = useMemo(() => makeTableData(data), [data]);
  const [search, clearSearch, filteredData] = useSearch(listData);

  const tableColumns = [
    { width: 150 , flexGrow: 0 , label: 'Identificador' , dataKey: '_id'       , sortKey: '_id'       , numeric: false } ,
    { width: 150 , flexGrow: 1 , label: 'Criado'        , dataKey: 'calendarT' , sortKey: 'timestamp' , numeric: true }  ,
    { width: 150 , flexGrow: 1 , label: 'Atualizado'    , dataKey: 'updateT'   , sortKey: 'validFrom' , numeric: true }  ,
    { width: 100 , flexGrow: 1 , label: 'Conteúdo'      , dataKey: 'eventT'    , sortKey: 'event'     , numeric: false } ,
  ];

  return isBusy
    ? <Grid container xs={12} justify='center'>
      <CircularProgress className={classes.spinner}/>
    </Grid>
    : <>
      <Search {...{clearSearch}} {...{search}}/>
      <Grid container className={classes.eventContainer}>
        {!isEmpty(filteredData)
          ? <Grid item xs={12}>
            <SimpleTable
              rowCount={filteredData.length}
              list={filteredData}
              rowHeight={78}
              onRowClick={onRowClick}
              columns={tableColumns}
            />
          </Grid>
          : <Grid container xs={12} justify='center'>
            <Typography variant='h6' className={classes.title}>
              Nenhum item encontrado...
            </Typography>
          </Grid>
        }
      </Grid>
    </>
};

export default View;
